<template>
<div>
   
   

    <i class="btn-up fa fa-arrow-circle-o-up hidden-xs"></i>
	<!--======================================== Navegación ========================================-->
	<header>

		

<div id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active" data-bs-interval="2000">
      <img src="../assets/fotos instalaciones/foto4.jpg" class="d-block w-100" alt=".." height="450" >
      <div class="carousel-caption d-none d-md-block">
		  <img src="../assets/logo.png" alt="Logo" class="img-responsive" height="60" width="60">
        <h5 style="color:#FFF">EPET N°16</h5>        
		<p style="color:#FFF">Escuela Provincial de Educación Técnica N° 16 - Rincón De Los Sauces - Neuquén</p>
			
      </div>
    </div>
    <div class="carousel-item" data-bs-interval="2000">
      <img src="../assets/fotos instalaciones/foto9.jpg" class="d-block w-100" alt=".." height="450">
      <div class="carousel-caption d-none d-md-block">
		  <img src="../assets/logo.png" alt="Logo" class="img-responsive" height="60" width="60">
        <h5 style="color:#FFF">EPET N°16</h5>
        <p style="color:#FFF">Escuela Provincial de Educación Técnica N° 16 - Rincón De Los Sauces - Neuquén</p>
		
      </div>
    </div>
    <div class="carousel-item">
      <img src="../assets/fotos instalaciones/foto1.png" class="d-block w-100" alt=".." height="450">
      <div class="carousel-caption d-none d-md-block">
		  <img src="../assets/logo.png" alt="Logo" class="img-responsive" height="60" width="60">
        <h5 style="color:#FFF">EPET N°16</h5>
        <p style="color:#FFF">Escuela Provincial de Educación Técnica N° 16 - Rincón De Los Sauces - Neuquén</p>
		
		
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

		
			
		



		
		<!--======================================== Boton menu mobil ========================================-->
		<!--<a href="#" class=" hidden-sm hidden-md hidden-lg pull-right button-menu-mobile show-close-menu-m"><i class="fa fa-ellipsis-v"></i></a>-->
	
    


	
	</header>
	<div class="divider-general"></div>

<br>
<br>









    
		<div class="container">
			
			<!--======================================== Carrusel ========================================-->
			
			<br>
			<div class="divider-general"></div>
			<br>
			<!--======================================== Video ========================================-->
			<div class="row">
				<div class="col-xs-12 col-sm-6">
					<h3 class="text-center titles">Video: Las Escuelas Técnicas En Argentina</h3>
					<p class="lead"></p>
					<i class="fa fa-film icon-index hidden-xs hidden-sm"></i>
				</div>
				<div class="col-xs-12 col-sm-6">
					<video controls>
						<source src="../assets/video/Introl.mp4" type="video/mp4">
					</video>
				</div>
			</div>
		</div>
		<section class="events-ins">
		<div class="container-fluid">

			<hr>
			<h2 class="text-center titles">PROYECTOS INSTITUCIONALES</h2>
			<br><br>
			<div class="row">
				<!--======================================== Articulo 1 ========================================-->
				<article class="col-xs-12 col-sm-6 col-md-4">
					<div class="thumbnail">
				      <img src="../assets/fotos estufa/foto7.jpg" alt="IMG" class="img-responsive img-rounded">
				      <div class="caption">
				        <h3 class="text-center">ESTUFA SOLIDARIA</h3>
				        <p class="text-justify">Las estufas Solidarias fueron diseñadas, fabricadas e intaladas por docentes de la escuela. En una iniciativa conjunta de la EPET 16, el Nucleamiento 5, la tornería Bollani, el sindicato ATEN y el Concejo Deliberante de Rincón de los Sauces, se diseño y se logro construir, estufas de alto rendimiento térmico, para entregar a las familias más necesitadas.</p>
				        
				      </div>
				    </div>
				</article>
				<article class="col-xs-12 col-sm-6 col-md-4">
					<div class="thumbnail">
				      <img src="../assets/fotos capacitacion/foto1.jpg" alt="IMG" class="img-responsive img-rounded">
				      <div class="caption">
				        <h3 class="text-center">CAPACITACIÓN DISEÑO INDUSTRIAL DOCENTES Y ESTUDIANTES</h3>
				        <p class="text-justify">Docentes y estudiantes, estan realizando una capacitación sobre diseño industrial e impresión 3d.</p>
				       
				      </div>
				    </div>
				</article>
				<!--======================================== Articulo 2 ========================================-->
				
				<!--======================================== Articulo 3 ========================================-->
				
			</div>
		</div>
	</section>
	<div class="divider-general"></div>
	<!--======================================== Enlaces importantes ========================================-->
	<section class="text-center important-links-index">
		<h2 class="titles">Sitios y enlaces importantes</h2>

		<a href="https://lazos.neuquen.edu.ar/" class="open-link-newTab">
			<i class="fa fa-graduation-cap"></i>
			<p>Plataforma Educativa Lazos</p>
		</a>

		<a href="http://www.inet.edu.ar/" class="open-link-newTab">
			<i class="fa fa-file-text-o"></i>
			<p>INET</p>
		</a>

		<a href="https://www.neuquen.edu.ar/" class="open-link-newTab">
			<i class="fa fa-file-text-o"></i>
			<p>Consejo Provincial de Educación</p>
		</a>

		<a href="https://juanamanso.edu.ar/" class="open-link-newTab">
			<i class="fa fa-file-text-o"></i>
			<p>Plan Federal Juana Manso</p>
		</a>

		<a href="https://edutics.neuquen.edu.ar/" class="open-link-newTab">
			<i class="fa fa-file-text-o"></i>
			<p>Portal Docente Neuquén</p>
		</a>

		
	</section>
      

      <hr class="my-5" />

      <!-- Section: Text -->
      
      <!-- Section: Text -->

      <!-- Section: Social -->
      
<!-- End of .container -->






</div>

	
</template>
 <script>




export default {
  name: "Inicio",
  components: {
   
  }
};
</script>







// WEBPACK FOOTER //
// src/components/Inicio.vue